if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

(function () {

    $('.scrolldownbtn').click(function (e) {
        e.preventDefault();
        const thisHref = $(this).attr('href');
        const hrefTop = $(thisHref).offset().top - 200;
        $('html,body').animate({
            scrollTop: hrefTop
        }, 1200);
    });

    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
    paragraph.forEach(e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));

    $('.sym-slides').slick({
        accessibility: false
    });

   


    $.fancybox.defaults.autoFocus = false;

    let current_url = document.URL;
    if (current_url.indexOf("#default=") != "-1") {
        let component = current_url.split("#default=");
        $("." + component[1]).click();
    }
})();

function ScrollToSection (elementTo, margin){
    if (elementTo){
        let formscrollY = elementTo.getBoundingClientRect().top + window.scrollY - margin;
        window.scrollTo({ behavior: "smooth", top: formscrollY });
    }
}

function simulateClicHref(href) {
    if((document.querySelectorAll('.js-dining-item')) && (href == "#mothers-day-menu")){
        let buttons = document.querySelectorAll('.js-dining-item');

        let target="14689";

        buttons.forEach(function(button) {
            if (button.getAttribute('data-target') === target) {
                let elementTo = document.querySelector('section.dining-entry__menu');
                setTimeout(function(){
                    button.click();
                    ScrollToSection (elementTo, 100);
                }, 3000);
            }
        });
    }
}

document.addEventListener('DOMContentLoaded', (event) => {

    let check_availability_button = document.getElementById('check_availability'),
        inner_bookings_buttons = document.querySelector('.inner_bookings_buttons');

    check_availability_button.addEventListener('click', (e) => {
        inner_bookings_buttons.classList.toggle('hidden');
    });

    let fragment = window.location.hash;
    if (fragment) {
        simulateClicHref(fragment);
    }

});